import { graphql, useStaticQuery } from 'gatsby'
import { useLangContext } from './lang.context'

function useMenu() {
  const { lang, toggleLang, setLang } = useLangContext()

  const query = useStaticQuery(graphql`
    query {
      blogs: allContentfulBlog(sort: { fields: date, order: DESC }) {
        edges {
          node {
            title
            seo_title
            blog_slug
            lang {
              slug
            }
          }
        }
      }

      industries: allContentfulIndustry(sort: { fields: name }) {
        edges {
          node {
            name
            slug
            lang {
              slug
            }
          }
        }
      }

      services: allContentfulService(sort: { fields: name }) {
        edges {
          node {
            name
            slug
            lang {
              slug
            }
          }
        }
      }

      locations: allContentfulLocation(sort: { fields: name }) {
        edges {
          node {
            name
            slug
            lang {
              slug
            }
          }
        }
      }

      depots: allContentfulDepot(sort: { fields: name }) {
        edges {
          node {
            name
            slug
            lang {
              slug
            }
          }
        }
      }
    }
  `)

  const linksBlogs = query.blogs.edges
    .filter(({ node }) => node.lang.slug === lang)
    .filter(({ node }) => node.title || node.seo_title)
    .filter((_, id) => id < 9)
    .map(({ node: { title, seo_title, blog_slug } }) => {
      const newtitle = title || seo_title
      return {
        name: newtitle.length > 50 ? newtitle?.slice(0, 50) + '...' : newtitle,
        slug: '/blog/' + blog_slug + '/',
      }
    })
    .concat({
      name: lang === 'pl' ? '...więcej artykułów' : '...more articles',
      slug: '/blog/',
    })

  const linksIndustires = query.industries.edges
    .filter(({ node }) => node.lang.slug === lang)
    .map(({ node: { name, slug } }) => ({
      name,
      slug: '/' + slug + '/',
    }))

  const linksServices = query.services.edges
    .filter(({ node }) => node.lang.slug === lang)
    .filter(({ node }) => node.slug !== 'b2b')
    .map(({ node: { name, slug } }) => ({
      name,
      slug: '/' + slug + '/',
    }))

  const linksLocations = query.locations.edges
    .filter(({ node }) => node.lang.slug === lang)
    .map(({ node: { name, slug } }) => ({
      name,
      slug: '/' + slug + '/',
    }))

  const linksDepots = query.depots.edges
    .filter(({ node }) => node.node_locale === 'pl')
    .map(({ node: { name, slug } }) => ({
      name,
      slug: '/' + slug + '/',
    }))

  const menu = [
    {
      slug: '/sklep/',
      title: {
        pl: 'Sklep',
        en: 'Sklep',
      },
      button: true,
    },
    {
      slug: '/b2b/',
      title: {
        pl: 'Współpraca B2B',
        en: 'B2B Cooperation',
      },
      // button: true,
    },
    {
      slug: '/wycena/',
      title: {
        pl: 'Wycena',
        en: 'Quote',
      },
    },
    {
      slug: '/uslugi/',
      title: {
        pl: 'Usługi',
        en: 'Services',
      },
      links: linksServices,
    },
    {
      slug: '/blog/',
      title: {
        pl: 'Blog',
        en: 'News',
      },
      links: linksBlogs,
    },
    {
      slug: '/firma/',
      title: {
        pl: 'Firma',
        en: 'Company',
      },
      links: [
        {
          slug: '/poznaj-nas/',
          title: {
            pl: 'Poznaj Nas',
            en: 'Discover Us',
          },
        },
        {
          slug: '/branze/',
          title: {
            pl: 'Branże',
            en: 'Branch',
          },
          links: linksIndustires,
        },
        {
          slug: '/miejscowosci/',
          title: {
            pl: 'Miejscowości',
            en: 'Locations',
          },
          links: linksLocations,
        },
        {
          slug: '/depoty/',
          title: {
            pl: 'Depoty',
            en: 'Depots',
          },
          links: linksDepots,
        },
        {
          slug: '/wspolpraca/',
          title: {
            pl: 'Współpraca',
            en: 'Collaboration',
          },
        },
        {
          slug: '/dla-mediow/',
          title: {
            pl: 'Dla Mediów',
            en: 'For Media',
          },
        },
      ],
    },
    {
      slug: '/kontakt/',
      title: {
        pl: 'Kontakt',
        en: 'Contact',
      },
    },
    {
      title: {
        pl: 'PL',
        en: 'EN',
        zh: '中国人',
      },
      slug: '/',
      links: [
        {
          name: '🇵🇱 Polski',
          slug: 'https://omidatrade.pl',
        },
        {
          name: '🇬🇧 English',
          slug: 'https://omidatrade.com/',
        },
        {
          name: '🇨🇳 中国人',
          slug: 'https://cn.omidatrade.com/',
        },
      ]
    },
  ]

  const footer = []

  return { menu, footer }
}

export default useMenu
